import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getSpeakerBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';
import { setUpdatedSpeakerDetailsToReviewApplicant } from '../classes/speaker/speakerProfile';
import { SpeakerApplicants } from '../../components/Speakers/speakerConstant';

import { uploadFileToBlobStorage } from './azurefilestorage';

const speakerPageState = () => {
    return {
        memberAssociationList: [],
        languagesList: [],
        feeRangeList: [],
        topicsList: [],
        countryList: null,
        baseURL: process.env.VUE_APP_SPEAKER_BASE_URL,
        pendingApplicants: [],
        reviewedApplicants: [],
        pendingApplicantsCount: 0,
        disablePAInfiniteScroll: false,
        noMoreActivityToFetch: false,
        nextListPageNumber: 1,
        userProfile: {},
        disableRAInfiniteScroll: false,
        noMorePendingApplicantsToFetch: false,
        nextHomePageSkip: 0,
        isBecomeASpeaker: false,
        noMoreReviewedApplicantsToFetch: false,
        nextRAPageSize: 1,
        nextRAPageSkip: 0,
        nextPAPageSkip: 0,

        rejectApplicant: false,
        approveApplicant: false,
        speakerProfile: null,
        isSpeakerApproved: false,
        speakerRegistrationStatus: null,
        canViewSpeakerAdminDirectory: false,
        prevRouteUrlName: '',
        currentlyViewingPendingOrReviewApplicantRecord: null,
        scrollPendingApplicantToViewMember: null,
        speakerStatus: {
            speakerType: '',
            approvalStatus: '',
        },
        regionListForCFF: [],
        minFeesRange: [],
        maxFeesRange: [],
    };
};

const speakerPageMutations = {
    [storeMutation.setSpeakerProfile]: (state, data) => {
        if (data) {
            if (data.profileImageUrl) {
                data.profileImageUrl = `${data.profileImageUrl}?${new Date().getTime()}`;
            }
            data.topics.forEach((parentTopic) => {
                parentTopic.selectedTopics = parentTopic.childTopics.filter(topic => topic.isSelected);
            });
        }
        if (data && !data.cffRegion) {
            data.cffRegion = {};
        }
        if (data && data.averageCffRating && data.averageCffRating.length > 8) {
            data.averageCffRating = data.averageCffRating.substring(0, 7);
        }
        state.speakerProfile = data || null;
    },
    [storeMutation.setScrollPendingApplicantToViewMember]: (state, memberId) => {
        state.scrollPendingApplicantToViewMember = memberId;
    },
    [storeMutation.setSpeakerStatus]: (state, data) => {
        state.speakerStatus.speakerType = data.speakerType;
        state.speakerStatus.approvalStatus = data.speakerStatus;
    },
    [storeMutation.setCanViewSpeakerAdminDirectory]: (state, data) => {
        state.canViewSpeakerAdminDirectory = data;
    },
    [storeMutation.setPrevRouteUrlName]: (state, data) => {
        state.prevRouteUrlName = data;
    },
    [storeMutation.setMemberAssoicationList]: (state, data) => {
        state.memberAssociationList = data;
    },
    [storeMutation.setLanguagesList]: (state, data) => {
        state.languagesList = data;
    },
    [storeMutation.setTopicsList]: (state, data) => {
        if (data.length > 0) {
            data.forEach((e) => {
                e.selectedTopics = [];
            });
        }
        state.topicsList = data;
    },
    [storeMutation.setFeeRangeList]: (state, data) => {
        state.feeRangeList = data;
    },
    [storeMutation.setMemberProfileDetails]: (state, data) => {
        state.userProfile = data;
    },
    [storeMutation.clearMemberProfileDetails]: (state) => {
        state.topicsList.forEach((d) => {
            d.selectedTopics = [];
        });
    },
    [storeMutation.setPendingApplicants]: (state, data) => {
        if (state.pendingApplicants && state.pendingApplicants.length) {
            let newItemPaused = false;
            data.forEach((item) => {
                const alreadyExist = state.pendingApplicants.some(it => it.speakerId === item.speakerId);
                if (!alreadyExist) {
                    state.pendingApplicants.push(item);
                    newItemPaused = true;
                }
            });
            if (newItemPaused) {
                state.nextPAPageSkip += 1;
            }
        } else {
            state.nextPAPageSkip += 1;
            state.nextPAPageSize += SpeakerApplicants.searchResultOffsetStep;
            state.pendingApplicants = data;
        }
    },
    [storeMutation.setPendingApplicantsCount]: (state, data) => {
        state.pendingApplicantsCount = data;
    },
    [storeMutation.setCurrentlyViewingPendingOrReviewApplicantRecord]: (state, data) => {
        state.currentlyViewingPendingOrReviewApplicantRecord = data;
    },
    [storeMutation.updateSpeakerEditDetailsToPendingOrApprovalList]: (state, speakerDetails) => {
        if (state.currentlyViewingPendingOrReviewApplicantRecord) {
            let reviewApplicant;
            if (state.currentlyViewingPendingOrReviewApplicantRecord.recordType === 'pending') {
                if (state.currentlyViewingPendingOrReviewApplicantRecord.speakerType === 'speaker') {
                    reviewApplicant = state.pendingApplicants.find(p => p.speakerId === state.currentlyViewingPendingOrReviewApplicantRecord.id);
                } else {
                    //'member'
                    reviewApplicant = state.pendingApplicants.find(p => p.personID === state.currentlyViewingPendingOrReviewApplicantRecord.id);
                }
            } else if (state.currentlyViewingPendingOrReviewApplicantRecord.speakerType === 'speaker') {
                reviewApplicant = state.reviewedApplicants.find(p => p.speakerId === state.currentlyViewingPendingOrReviewApplicantRecord.id);
            } else {
                //'member'
                reviewApplicant = state.reviewedApplicants.find(p => p.personID === state.currentlyViewingPendingOrReviewApplicantRecord.id);
            }
            if (reviewApplicant) {
                setUpdatedSpeakerDetailsToReviewApplicant(reviewApplicant, speakerDetails);
            }
        }
    },
    [storeMutation.setReviewedApplicants]: (state, data) => {
        if (state.reviewedApplicants && state.reviewedApplicants.length) {
            let newItemPaused = false;
            data.forEach((item) => {
                const alreadyExist = state.reviewedApplicants.some(it => it.speakerId === item.speakerId);
                if (!alreadyExist) {
                    state.reviewedApplicants.push(item);
                    newItemPaused = true;
                }
            });

            if (newItemPaused) {
                state.nextRAPageSkip += 1;
            }
        } else {
            state.nextRAPageSkip += 1;
            state.nextRAPageSize += SpeakerApplicants.searchResultOffsetStep;
            state.reviewedApplicants = data;
        }
    },
    [storeMutation.setSpeakerRegistrationStatus]: (state, data) => {
        state.speakerRegistrationStatus = data;
    },
    [storeMutation.setPAInfiniteScrollState]: (state, data) => {
        state.disablePAInfiniteScroll = data;
    },
    [storeMutation.setRAInfiniteScrollState]: (state, data) => {
        state.disableRAInfiniteScroll = data;
    },

    [storeMutation.resetPendingApplicantsList]: (state) => {
        state.pendingApplicants = null;
        state.nextListPageNumber = 1;
        state.nextPAPageSkip = 0;
        state.noMorePendingApplicantsToFetch = false;
    },

    [storeMutation.resetReviewedApplicantsList]: (state) => {
        state.reviewedApplicants = null;
        state.nextListPageNumber = 1;
        state.nextRAPageSkip = 0;
        state.noMoreReviewedApplicantsToFetch = false;
    },
    [storeMutation.setIsBecomeASpeaker]: (state, data) => {
        state.isBecomeASpeaker = data;
    },

    [storeMutation.setRejectApplicant]: (state, data) => {
        state.rejectApplicant = data;
    },
    [storeMutation.setApproveApplicant]: (state, data) => {
        state.approveApplicant = data;
    },

    [storeMutation.setIsSpeakerApproved]: (state, data) => {
        state.isSpeakerApproved = data;
    },
    [storeMutation.setCountryList]: (state, data) => {
        state.countryList = data;
    },
    [storeMutation.setRegionList]: (state, data) => {
        state.regionListForCFF = data;
    },
    [storeMutation.setFeesRange]: (state, data) => {
        state.minFeesRange = data.minRanges;
        state.maxFeesRange = data.maxRanges;
    },
};

const speakerPageActions = {
    [storeAction.getMemberAssociationList]: async ({ state, commit }) => {
        commit(storeMutation.setMemberAssoicationList, '');
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}speaker/api/speaker/get/Associations`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setMemberAssoicationList, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.getSpeakerRegistrationStatus]: async ({ state, commit }, personId) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}speaker/api/speaker/speaker-registration-status/${personId}`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setSpeakerRegistrationStatus, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.getIsSpeakerApproved]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}speaker/api/speaker/is-approved-speaker`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setIsSpeakerApproved, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },

    [storeAction.getLanguagesList]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}speaker/api/speaker/get/languages`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setLanguagesList, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.getTopicsList]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}speaker/api/speaker/get/Topics`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setTopicsList, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.getFeeRangeList]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}speaker/api/speaker/get/feerange`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setFeeRangeList, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.getMemberProfileDetails]: async ({ state, commit }, personId) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}profiles/api/Speaker/PersonProfile/${personId}`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setMemberProfileDetails, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.getBasicOptionsForSpeaker]: wrapAction(storeAction.getBasicOptionsForSpeaker, ({ state, dispatch }) => {
        return new Promise((resolve, reject) => {
            const countryList = state.countryList ? Promise.resolve() : dispatch(storeAction.getCountryList);
            const associationList =
                state.memberAssociationList && state.memberAssociationList.length
                    ? Promise.resolve()
                    : dispatch(storeAction.getMemberAssociationList);
            const languageList =
                state.languagesList && state.languagesList.length
                    ? Promise.resolve()
                    : dispatch(storeAction.getLanguagesList);
            const topicList =
                state.topicsList && state.topicsList.length ? Promise.resolve() : dispatch(storeAction.getTopicsList);
            const feeRangeList =
                state.feeRangeList && state.feeRangeList.length
                    ? Promise.resolve()
                    : dispatch(storeAction.getFeeRangeList);

            Promise.all([countryList, associationList, languageList, topicList, feeRangeList])
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    }),

    //Pending Applicants Action Method
    [storeAction.getPendingApplicants]: wrapAction(storeAction.getPendingApplicants, ({ state, commit }) => {
        state.nextPAPageSkip =
            state.pendingApplicants.length >= SpeakerApplicants.searchResultOffsetStep ? state.nextPAPageSkip : 0;
        const PASkipNumber = state.nextPAPageSkip * SpeakerApplicants.searchResultOffsetStep;
        const PAPageSize = SpeakerApplicants.searchResultOffsetStep;
        commit(storeMutation.setPAInfiniteScrollState, true);
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}speaker/api/speaker/get-pending-speakers?skipNumber=${PASkipNumber}&takeSize=${PAPageSize}`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    if (response && response.data) {
                        if (!response.data.length || response.data.length < PAPageSize) {
                            state.noMorePendingApplicantsToFetch = true;
                        }
                    }
                    commit(storeMutation.setPendingApplicants, response.data);
                    commit(storeMutation.setPAInfiniteScrollState, false);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    commit(storeMutation.setPendingApplicants, []);
                    commit(storeMutation.setPAInfiniteScrollState, false);
                    console.log(err);
                    reject(err);
                });
        });
    }),
    [storeAction.uploadFilesToTemporaryStorage]: wrapAction(
        storeAction.uploadFilesToTemporaryStorage,
        ({ state, rootGetters }, postData) => {
            return axios({
                url: `${state.baseURL}uploads/api/upload/speakerProfile/${rootGetters[storeGetters.communityName]}`,
                headers: getSpeakerBasicHeaders(),
                data: postData.selectedFiles,
                method: 'POST',
            })
                .then((response) => {
                    return response.data;
                })
                .catch((err) => {
                    console.error('whoops! (submitPostEdit)', err);
                    throw err;
                });
        },
    ),

    [storeAction.getPendingApplicantsCount]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}speaker/api/speaker/pending-speakers-count`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setPendingApplicantsCount, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.getReviewedApplicants]: wrapAction(
        storeAction.getReviewedApplicants,
        ({ state, commit }, statusType) => {
            const skipNumber = state.nextRAPageSkip * SpeakerApplicants.searchResultOffsetStep;
            const pageSize = SpeakerApplicants.searchResultOffsetStep;
            let newUrl = `${state.baseURL}speaker/api/speaker/get-reviewed-speakers?skipNumber=${skipNumber}&takeSize=${pageSize}`;
            if (statusType != null) {
                newUrl = `${state.baseURL}speaker/api/speaker/get-reviewed-speakers?skipNumber=${skipNumber}&takeSize=${pageSize}&status=${statusType}`;
            } else {
                newUrl = `${state.baseURL}speaker/api/speaker/get-reviewed-speakers?skipNumber=${skipNumber}&takeSize=${pageSize}`;
            }
            commit(storeMutation.setRAInfiniteScrollState, true);
            return new Promise((resolve, reject) => {
                axios({
                    url: newUrl,
                    headers: getSpeakerBasicHeaders(),
                    method: 'GET',
                })
                    .then((response) => {
                        if (response && response.data) {
                            if (!response.data.length || response.data.length < pageSize) {
                                state.noMoreReviewedApplicantsToFetch = true;
                            }
                        }
                        commit(storeMutation.setReviewedApplicants, response.data);
                        commit(storeMutation.setRAInfiniteScrollState, false);
                        resolve(response);
                    })
                    .catch((err) => {
                        //TODO: handle error
                        commit(storeMutation.setReviewedApplicants, []);
                        commit(storeMutation.setRAInfiniteScrollState, false);
                        console.log(err);
                        reject(err);
                    });
            });
        },
    ),
    // [storeAction.submitRegistrationForm]: wrapAction(
    //     storeAction.submitRegistrationForm,
    //     async ({ state, dispatch }, data) => {
    //         return new Promise(async (resolve1, reject1) => {
    //             const mediaObject = uploadVideoImageBlob(state.baseURL, data);
    //             mediaObject
    //                 .then((mObject) => {
    //                     data.speakerData.presentationUrl = mObject.videoName;
    //                     data.speakerData.profileImageUrl = mObject.ImageName;
    //                     dispatch(storeAction.uploadSpeakerRegistrationData, data.speakerData)
    //                         .then((res) => {
    //                             resolve1(res);
    //                         })
    //                         .catch((err) => {
    //                             console.log(err);
    //                             reject1(err);
    //                         });
    //                 })
    //                 .catch((err) => {
    //                     console.log(err);
    //                     reject1(err);
    //                 });
    //         });
    //     },
    // ),

    // [storeAction.uploadSpeakerRegistrationFiles]: async ({ state }, formData) => {
    //     return axios({
    //         url: `${state.baseURL}speaker/api/speaker/upload-speaker-presentation-and-image`,
    //         headers: getSpeakerBasicHeaders(),
    //         data: formData,
    //         method: 'POST',
    //     })
    //         .then((response) => {
    //             return response.data;
    //         })
    //         .catch((err) => {
    //             //TODO: handle error
    //             console.log(err);
    //             throw err;
    //         });
    // },
    [storeAction.uploadSpeakerRegistrationData]: wrapAction(
        storeAction.uploadSpeakerRegistrationData,
        async ({ state }, speakerData) => {
            return axios({
                url: `${state.baseURL}speaker/api/speaker/save-speaker`,
                headers: getSpeakerBasicHeaders(),
                data: speakerData,
                method: 'POST',
            })
                .then((response) => {
                    state.speakerRegistrationStatus = 'P';
                    return response;
                })
                .catch((err) => {
                    state.speakerRegistrationStatus = null;
                    console.log(err);
                    throw new Error('speaker data error');
                });
        },
    ),

    //speaker Upload new image API call

    [storeAction.updateSpeakerProfileImage]: async ({ state }, formData) => {
        return axios({
            url: `${state.baseURL}speaker/api/speaker/upload-speaker-profile-image`,
            headers: getSpeakerBasicHeaders(),
            data: formData,
            'Content-Type': 'multipart/form-data',
            method: 'POST',
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.error(err);
                throw err;
            });
    },

    //ending

    [storeAction.uploadSpeakerRegistrationProfileImage]: wrapAction(
        storeAction.uploadSpeakerRegistrationProfileImage,
        async ({ state }, profileImageData) => {
            return new Promise(async (resolve) => {
                uploadFileToBlobStorage(profileImageData.file, profileImageData.fileName, state.baseURL, 2)
                    .then((fileName) => {
                        resolve(fileName);
                    })
                    .catch((err) => {
                        setTimeout(() => {
                            uploadFileToBlobStorage(profileImageData.file, profileImageData.fileName, state.baseURL, 2)
                                .then((fileName) => {
                                    resolve(fileName);
                                })
                                .catch((error) => {
                                    resolve(new Error('blob_error_profileImage'));
                                    console.error(error);
                                });
                        }, 10000);
                        console.error(err);
                    });
            });
        },
    ),
    [storeAction.uploadSpeakerRegistrationPresentation]: wrapAction(
        storeAction.uploadSpeakerRegistrationPresentation,
        async ({ state }, presentationFile) => {
            return new Promise(async (resolve) => {
                uploadFileToBlobStorage(presentationFile.file, presentationFile.fileName, state.baseURL, 1)
                    .then(() => {
                        resolve({ fileName: presentationFile.fileName, retryCount: 0 });
                    })
                    .catch((err) => {
                        setTimeout(() => {
                            uploadFileToBlobStorage(presentationFile.file, presentationFile.fileName, state.baseURL, 1)
                                .then(() => {
                                    resolve({ fileName: presentationFile.fileName, retryCount: 1 });
                                })
                                .catch((error) => {
                                    resolve({ error, retryCount: 1 });
                                });
                        }, 40000);
                        console.error(err);
                    });
            });
        },
    ),
    //Is-Become-a-Speaker
    [storeAction.getBecomeASpeaker]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}speaker/api/speaker/is-become-speaker`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setIsBecomeASpeaker, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },

    [storeAction.getYPOSpeakers]: async ({ commit }) => {
        return new Promise((resolve, reject) => {
            axios({
                url: '/mocks/YPOSpeakers.json',
                // url: `${state.baseURL}speaker/api/speaker/pending-speakers-count`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setYPOSpeakers, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.getRejectApplicant]: async ({ state, commit }, rejectApplicantObj) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}speaker/api/speaker/reject-speaker-request`,
                headers: getSpeakerBasicHeaders(),
                data: rejectApplicantObj,
                method: 'POST',
            })
                .then((response) => {
                    commit(storeMutation.setRejectApplicant, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },

    [storeAction.getApproveApplicant]: async ({ state, commit }, approveApplicantObj) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}speaker/api/speaker/approve-speaker-request`,
                headers: getSpeakerBasicHeaders(),
                data: approveApplicantObj,
                method: 'POST',
            })
                .then((response) => {
                    commit(storeMutation.setApproveApplicant, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.uploadProfilePhoto]: wrapAction(storeAction.uploadProfilePhoto, ({ state, commit }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/member-profile/upload-profile-photo-speaker`,
            headers: getSpeakerBasicHeaders(),
            method: 'POST',
            data: requestBody,
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.saveEditedSpeakerProfile]: wrapAction(
        storeAction.saveEditedSpeakerProfile,
        async ({ state, commit }, profileObj) => {
            return axios({
                url: `${state.baseURL}speaker/api/speaker/edit-speaker`,
                headers: getSpeakerBasicHeaders(),
                data: profileObj,
                method: 'POST',
            })
                .then((response) => {
                    //TODO: Need to handle what to do after Save
                    commit(storeMutation.setSpeakerProfile, response.data);
                    return response;
                })
                .catch((err) => {
                    throw err;
                });
        },
    ),
    [storeAction.getSpeakerProfile]: wrapAction(storeAction.getSpeakerProfile, ({ state, commit }, profileObj) => {
        return axios({
            url: `${state.baseURL}speaker/api/speaker/speaker-profile-info`,
            headers: getSpeakerBasicHeaders(),
            data: profileObj,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setSpeakerProfile, response.data);
                return response;
            })
            .catch((err) => {
                commit(storeMutation.setSpeakerProfile, null);
                throw err;
            });
    }),

    [storeAction.getCanViewSpeakerAdminDirectory]: wrapAction(
        storeAction.getCanViewSpeakerAdminDirectory,
        async ({ state, commit }) => {
            return axios({
                url: `${state.baseURL}speaker/api/speaker/can-view-speaker-admin-directory`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setCanViewSpeakerAdminDirectory, response.data);
                    return true;
                })
                .catch((err) => {
                    commit(storeMutation.setCanViewSpeakerAdminDirectory, null);
                    throw err;
                });
        },
    ),
    [storeAction.getCountryList]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}speaker/api/speaker/get/country-and-states`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setCountryList, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.getRegionListForCFF]: async ({ state, commit }) => {
        if (!state.regionListForCFF || state.regionListForCFF.length === 0) {
            return axios({
                url: `${state.baseURL}speaker/api/speaker/getregions`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setRegionList, response.data);
                    return response;
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    throw err;
                });
        }
    },

    [storeAction.getFeesRange]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}speaker/api/speaker/getfeeranges`,
                headers: getSpeakerBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setFeesRange, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
};

const speakerPageGetters = {
    [storeGetters.memberAssociationList]: state => state.memberAssociationList,
    [storeGetters.languagesList]: state => state.languagesList,
    [storeGetters.topicsList]: state => state.topicsList,
    [storeGetters.feeRangeList]: state => state.feeRangeList,
    [storeGetters.memberProfileDetails]: state => state.memberProfileDetails,
    [storeGetters.pendingApplicants]: state => state.pendingApplicants,
    [storeGetters.reviewedApplicants]: state => state.reviewedApplicants,
    [storeGetters.pendingApplicantsCount]: state => state.pendingApplicantsCount,
    [storeGetters.disablePAInfiniteScroll]: state => state.disablePAInfiniteScroll,
    [storeGetters.disableRAInfiniteScroll]: state => state.disableRAInfiniteScroll,
    [storeGetters.isBecomeASpeaker]: state => state.isBecomeASpeaker,
    [storeGetters.noMoreReviewedApplicantsToFetch]: state => state.noMoreReviewedApplicantsToFetch,
    [storeGetters.noMorePendingApplicantsToFetch]: state => state.noMorePendingApplicantsToFetch,

    [storeGetters.rejectApplicant]: state => state.rejectApplicant,
    [storeGetters.approveApplicant]: state => state.approveApplicant,
    [storeGetters.speakerProfile]: state => state.speakerProfile,
    [storeGetters.isSpeakerApproved]: state => state.isSpeakerApproved,
    [storeGetters.speakerRegistrationStatus]: state => state.speakerRegistrationStatus,
    [storeGetters.canViewSpeakerAdminDirectory]: state => state.canViewSpeakerAdminDirectory,
    [storeGetters.prevRouteUrlName]: state => state.prevRouteUrlName,
    [storeGetters.countryList]: state => state.countryList,
    [storeGetters.speakerStatus]: state => state.speakerStatus,
    [storeGetters.scrollPendingApplicantToViewMember]: state => state.scrollPendingApplicantToViewMember,
    [storeGetters.speakerUserProfile]: state => state.userProfile,
    [storeGetters.regionListForCFF]: state => state.regionListForCFF,
    [storeGetters.regionListForCFFNames]: state => state.regionListForCFF.map(x => x.name),
    [storeGetters.maxFeesRange]: state => state.maxFeesRange,
    [storeGetters.minFeesRange]: state => state.minFeesRange,
};

export default {
    namespaced: true,
    state: {
        initialState: speakerPageState(),
        ...speakerPageState(),
    },
    mutations: { ...speakerPageMutations },
    actions: { ...speakerPageActions },
    getters: { ...speakerPageGetters },
};
